import Grid2 from "@mui/material/Unstable_Grid2";
import { CircularProgress } from "@mui/material";
import React, { useRef } from "react";
import PropTypes from "prop-types";
import { categories } from "../store/constant/constant";
import MKBox from "../components/MKBox";
import MKButton from "../components/MKButton";
import CollectionCard from "./Cards/CollectionCard";
import MKTypography from "../components/MKTypography";
import typography from "../assets/theme/base/typography";

const { size } = typography;

const CollectionHub = ({ collections, linkPrefix }) => {
  const contentRefs = categories.map((item) => ({
    name: item,
    ref: useRef(null),
  }));
  return (
    <Grid2
      xs={12}
      container
      mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 48 }}
      mt={{ sm: 1, xl: 2, xxl: 3, xxxl: 4 }}
      maxWidth={1600}
    >
      <Grid2
        xs={2.5}
        sx={{
          display: { xs: "none", lg: "block" },
        }}
      >
        <MKBox width="100%" position="sticky" top="0px">
          <Grid2 xs={12}>
            <MKBox
              sx={{
                width: 1,
                py: 1,
                mb: 1,
                background: "#C7D6CF",
              }}
            >
              <MKTypography
                align="center"
                variant="h5"
                color="primary"
                sx={{ fontSize: size["3xl"] }}
              >
                Category
              </MKTypography>
            </MKBox>
          </Grid2>
          {contentRefs.map((item) => (
            <Grid2 xs={12} key={item.name} sx={{ py: 1, background: "#EFF2F1" }}>
              <MKButton
                variant="text"
                color="secondary"
                fullWidth
                sx={{ fontSize: size.xl, textTransform: "capitalize" }}
                onClick={() => {
                  item.ref.current.scrollIntoView({ behavior: "smooth" });
                }}
              >
                {item.name}
              </MKButton>
            </Grid2>
          ))}
        </MKBox>
      </Grid2>
      <Grid2
        xs={12}
        lg={9.5}
        xxxl={8}
        sx={{
          pl: 1,
          borderColor: ({ palette: { primary }, functions: { rgba } }) =>
            `${rgba(primary.main, 0.2)}`,
        }}
      >
        {collections.length === 0 ? (
          <MKBox sx={{ display: "flex" }}>
            <CircularProgress />
          </MKBox>
        ) : (
          contentRefs.map((item) => (
            <Grid2 xs={12} key={item.name}>
              <MKBox ref={item.ref}>
                {collections
                  .filter(
                    (collection) => collection.summaries.info.category.toLowerCase() === item.name
                  )
                  .map((collection) => (
                    <CollectionCard
                      key={collection.id}
                      collection={collection}
                      linkPrefix={linkPrefix}
                    />
                  ))}
              </MKBox>
            </Grid2>
          ))
        )}
      </Grid2>
    </Grid2>
  );
};

CollectionHub.propTypes = {
  collections: PropTypes.arrayOf(PropTypes.object).isRequired,
  linkPrefix: PropTypes.string.isRequired,
};

export default CollectionHub;
